<template>
    <CertificateBody
        v-if="player.uuid && !isBadgeMode"
        @updateIframeHeight="updateHeight"
        :player="player"
        :certTemplate="certTemplate"
        :certContent="certContent"
        :issuedCert="exampleIssuedCert"
    />
    <BadgeBody
        v-if="player.uuid && isBadgeMode"
        @updateIframeHeight="updateHeight"
        :player="player"
        :certTemplate="certTemplate"
        :certContent="certContent"
        :issuedCert="exampleIssuedCert"
    />
</template>

<script>
import { mapMutations, mapState } from "vuex";
import CertificateBody from "@/views/tools/player/certificate/CertificateBody.vue";
import BadgeBody from "@/views/tools/player/certificate/BadgeBody.vue";
import { setFontFamily, updateIframeHeight } from "@/shared/utils";
import { preparePlayer } from "@/shared/projects/prepareData";
import { PREVIEW_ROUTE_NAMES } from "@/views/preview/preview.routes";
import { useAsyncVuexModules } from "@/store/useAsyncVuexModules";
import playerViewModule from "@/views/tools/player/store/player-view.store";
import { projectsService } from "@/shared/projects/projects.service";

export default {
    name: "PlayerCertificatePreview",
    components: {
        CertificateBody,
        BadgeBody,
    },
    setup() {
        useAsyncVuexModules(["player/view", playerViewModule]);
    },
    data() {
        return {
            isBadgeMode: this.$route.name === PREVIEW_ROUTE_NAMES.playerBadge,
            windowWidth: window.innerWidth,
            currentFont: "Inter",
            waiting: false,
            exampleIssuedCert: {
                createdAt: new Date(),
                uuid: "example",
                userName: "John Doe",
            },
        };
    },
    computed: {
        ...mapState("player/view", ["player"]),
        certTemplate() {
            return this.player?.certificate || {};
        },
        certContent() {
            return this.player.certificate?.content || {};
        },
    },
    async mounted() {
        if (window.location === window.parent.location) {
            try {
                const player = await this.loadPlayer(this.$route.params.projectUuid);
                this.setPlayer(player);
                this.adjustIframe();
            } catch {
                this.$router.push({ name: PREVIEW_ROUTE_NAMES.notFound });
            }
        } else {
            window.addEventListener("message", this.handleParentAction);
        }

        window.addEventListener("resize", this.resizeIframe);
    },
    beforeUnmount() {
        window.removeEventListener("message", this.handleParentAction);
        window.removeEventListener("resize", this.resizeIframe);
    },
    methods: {
        ...mapMutations("player/view", ["setPlayer"]),
        async loadPlayer(uuid) {
            this.waiting = true;
            const player = await projectsService.getOne({ tool: "player", uuid });
            this.waiting = false;
            return preparePlayer(player);
        },
        handleParentAction(e) {
            if (e.data?.action === "playerDataChanged") {
                const player = preparePlayer(e.data.payload || {});
                this.setPlayer(player);
                this.adjustIframe();
            }
        },
        async adjustIframe() {
            this.currentFont = setFontFamily(this.player.fontFamily, this.currentFont);
            await this.$nextTick();
            this.updateHeight();
        },
        updateHeight() {
            updateIframeHeight("player", this.player.uuid);
        },
        resizeIframe() {
            if (window.innerWidth !== this.windowWidth) {
                this.adjustIframe();
                this.windowWidth = window.innerWidth;
            }
        },
    },
};
</script>
